import { useEffect } from 'react';

import { UserData } from '@partoohub/api-client';
import { setDefaultOptions } from 'date-fns';

import i18n from 'app/common/translations/i18n';
import { getDateFnsLocaleFromLocale } from 'app/common/utils/dateFns';

/**
 * Handle language changes for i18n and html lang attribute
 */
export const useHandleLanguageChanges = (me: UserData | undefined) => {
    useEffect(() => {
        if (me) {
            try {
                if (me.lang !== i18n.language) {
                    i18n.changeLanguage(me.lang);
                }

                const html = document.getElementsByTagName('html');

                if (html?.[0]) {
                    html[0].setAttribute('lang', me.lang);
                    const locale = getDateFnsLocaleFromLocale(me.lang);
                    setDefaultOptions(locale);
                }
            } catch (error) {
                console.error(error);
            }
        }
    }, [me]);
};
